// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XiAl","col":"styles_col__36i7F"};